import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { toast } from 'react-toastify';
import * as req from '../../../../axios/request/SocietyPortal/BRSReqs/BRSReqs'

const extractError = (e, fallback) =>
    e?.response?.data?.message || e?.data?.message || e?.message || fallback;

const makeHandler = ({ reqFn, successType, failureType, successMsg, failureMsg, silentSuccess }) => {
    return function* (action) {
        try {
            const result = yield call(reqFn, action);
            if (result?.success === true) {
                if (!silentSuccess) toast.success(result.message || successMsg);
                yield put({ type: successType, payload: result });
                action?.data?.onSuccess?.(result);
            } else {
                const msg = result?.message || failureMsg;
                yield put({ type: failureType, message: msg });
                toast.error(msg);
            }
        } catch (e) {
            console.log(e);
            const msg = extractError(e, failureMsg);
            yield put({ type: failureType, message: msg });
            toast.error(msg);
        }
    };
};

const getBRSList = makeHandler({
    reqFn: req.getBRSListReq,
    successType: types.GET_BRS_LIST_SUCCESS,
    failureType: types.GET_BRS_LIST_FAILURE,
    failureMsg: 'Failed to fetch BRS list',
    silentSuccess: true,
});

const getBRSDetails = makeHandler({
    reqFn: req.getBRSDetailsReq,
    successType: types.GET_BRS_DETAILS_SUCCESS,
    failureType: types.GET_BRS_DETAILS_FAILURE,
    failureMsg: 'Failed to fetch BRS details',
    silentSuccess: true,
});

const createBRS = makeHandler({
    reqFn: req.createBRSReq,
    successType: types.CREATE_BRS_SUCCESS,
    failureType: types.CREATE_BRS_FAILURE,
    successMsg: 'BRS created successfully',
    failureMsg: 'Failed to create BRS',
});

const updateBRS = makeHandler({
    reqFn: req.updateBRSReq,
    successType: types.UPDATE_BRS_SUCCESS,
    failureType: types.UPDATE_BRS_FAILURE,
    successMsg: 'BRS updated',
    failureMsg: 'Failed to update BRS',
});

const finalizeBRS = makeHandler({
    reqFn: req.finalizeBRSReq,
    successType: types.FINALIZE_BRS_SUCCESS,
    failureType: types.FINALIZE_BRS_FAILURE,
    successMsg: 'BRS finalized',
    failureMsg: 'Failed to finalize BRS',
});

const deleteBRS = makeHandler({
    reqFn: req.deleteBRSReq,
    successType: types.DELETE_BRS_SUCCESS,
    failureType: types.DELETE_BRS_FAILURE,
    successMsg: 'BRS deleted',
    failureMsg: 'Failed to delete BRS',
});

const clearBRSEntries = makeHandler({
    reqFn: req.clearBRSEntriesReq,
    successType: types.CLEAR_BRS_ENTRIES_SUCCESS,
    failureType: types.CLEAR_BRS_ENTRIES_FAILURE,
    successMsg: 'Entries cleared',
    failureMsg: 'Failed to clear entries',
});

const importBRSStatement = makeHandler({
    reqFn: req.importBRSStatementReq,
    successType: types.IMPORT_BRS_STATEMENT_SUCCESS,
    failureType: types.IMPORT_BRS_STATEMENT_FAILURE,
    successMsg: 'Bank statement imported',
    failureMsg: 'Failed to import bank statement',
});

const autoMatchBRS = makeHandler({
    reqFn: req.autoMatchBRSReq,
    successType: types.AUTO_MATCH_BRS_SUCCESS,
    failureType: types.AUTO_MATCH_BRS_FAILURE,
    successMsg: 'Auto-match completed',
    failureMsg: 'Auto-match failed',
});

const manualMatchBRS = makeHandler({
    reqFn: req.manualMatchBRSReq,
    successType: types.MANUAL_MATCH_BRS_SUCCESS,
    failureType: types.MANUAL_MATCH_BRS_FAILURE,
    successMsg: 'Matched',
    failureMsg: 'Failed to match',
});

const unmatchBRS = makeHandler({
    reqFn: req.unmatchBRSReq,
    successType: types.UNMATCH_BRS_SUCCESS,
    failureType: types.UNMATCH_BRS_FAILURE,
    successMsg: 'Unmatched',
    failureMsg: 'Failed to unmatch',
});

export default function* BRSSaga() {
    yield takeLatest(types.GET_BRS_LIST, getBRSList);
    yield takeLatest(types.GET_BRS_DETAILS, getBRSDetails);
    yield takeLatest(types.CREATE_BRS, createBRS);
    yield takeLatest(types.UPDATE_BRS, updateBRS);
    yield takeLatest(types.FINALIZE_BRS, finalizeBRS);
    yield takeLatest(types.DELETE_BRS, deleteBRS);
    yield takeLatest(types.CLEAR_BRS_ENTRIES, clearBRSEntries);
    yield takeLatest(types.IMPORT_BRS_STATEMENT, importBRSStatement);
    yield takeLatest(types.AUTO_MATCH_BRS, autoMatchBRS);
    yield takeLatest(types.MANUAL_MATCH_BRS, manualMatchBRS);
    yield takeLatest(types.UNMATCH_BRS, unmatchBRS);
}
